import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment'
export function isObject(x: any): x is Object {
  return x != null && typeof x === 'object';
}
export function isArray(x: any):boolean{
    if(x==null){ return false;}
    if(isObject(x)===false){ false;}
    return (!x.length)? false: true;
}

export function isString(value){ return (typeof value=='string' ? true: false ); }
export function isFunction(value) { return  typeof value ==='function'  ? true: false; }
export function empty(value: any): boolean {
  let tipo:string=typeof value;
    
  
    var isVazio=function(valor){
      switch (valor) {
        case "":
        case 0:
        case "0":
        case false:
        case null:  
          return true;
        default:
          return false;
      }  
    }
    if(isVazio(value)===true){
        return true;
    }
    switch(tipo){
       case "undefined":
        return true;
      case "object":
      case "Array":    
        return (Object.keys(value).length==0);
      case 'number':
         return isVazio(value);
      break;
      case 'string':
        return isVazio(value.trim());
      break;  
      case 'boolean':    
        return isVazio(value);
      default:
          return false;
    } 
    
    /**
     * function',
    '[object RegExp]'  : 'regexp',
    '[object Array]'   : 'array',
    '[object Date]'    : 'date',
    '[object Error]'   : 'error'
     * */    
}
@Injectable({
  providedIn: 'root'
})
export class InstiHelpers {
   arrayColumn(arra, name){
        var retorno=[];
        let x:number=0;
        for(x=0; x<arra.length; x++){
             if(isObject(arra[x])===false || empty(arra[x])){
                 continue;
             }
             if(arra[x].hasOwnProperty(name)===false){
                 continue;
             }
            retorno.push(arra[x][name]); 
        }
        return retorno;
     }
    arrayUnique(arra){
        var removeDuplicate=function(value, index, self) { 
                return self.indexOf(value) === index;
            }        
        return  isArray(arra) ? arra.filter(removeDuplicate) : arra;
    }
    empty(value):boolean{ return empty(value);}
    isObject(value){ return isObject(value);}
    isArray(value){ return isArray(value)}
    isNumber(value){ return !isNaN(value)}
    toInt(value,returnNaN?){ 
      let a = parseInt(value);
      return isNaN(a) ? (returnNaN===true? a: 0) : a;     
    }
    toFloat(value,returnNan?){
      return this.isNumber(value) ? (this.isString(value) ? parseFloat(value) : value): (returnNan === true? 0 : value);
      
    }
    parseDateToBr(value){
      return value;
    }
    isString(value){ 
    return isString(value); 
    }
    findRecursive(obj, key) {
        /*
        if (obj.value && obj.value.indexOf(key) > -1){
          return true;
        }
        if (obj.children && obj.children.length > 0){
          return obj.children.reduce(function(obj1, obj2){
            return find(obj1, key) || find(obj2, key);
          }, {}); 
        } 
        return false;
        -*/
    }

}
